import { AxiosError } from 'axios';
import React, { useContext, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ErrorResponse } from '../../../../shared/api/hscan';
import { KeycloakErrorResponseDetail } from '../../../../shared/api/hscan/account';
import {
  useChangePhoneNumber,
  useUserState,
} from '../../../../shared/hooks/accountHook';
import { useIamport } from '../../../../shared/hooks/iamportHook';
import { CertificationResponse } from '../../../../shared/utils/iamport';
import {
  CertificationButton,
  EditDescription,
  EditInputContainer,
  EditInputField,
  EditInputLabel,
  EditInputText,
  EditTitle,
  ErrorMessage,
  MobileEditTitle,
} from '../../common/components/EditModal/styledComponents';
import { Loading } from '../../common/components/Loading';
import { WindowSizeContext, WindowSize } from '../../hooks/windowSizeHook';

interface EditPhoneProps {
  onClose: () => void;
}
export const EditPhone = (props: EditPhoneProps) => {
  const { onClose } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.myPage.edit.phone',
  });
  const [user] = useUserState();
  const { isLoading, isPending, certificate } = useIamport();
  const { mutate: changePhoneNumber } = useChangePhoneNumber({
    onSuccess: onClose,
    onError: (e: AxiosError<ErrorResponse<KeycloakErrorResponseDetail>>) => {
      if (e.response?.status === 500) {
        setErrorMessage(`${t('errorMessage.500')}`);
      } else {
        setErrorMessage(
          `${t(
            `errorMessage.${e.response?.data.code}`,
            t('errorMessage.unknown'),
          )}`,
        );
      }
    },
  });
  const [newPhone, setNewPhone] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const certificationCallback = (response: CertificationResponse) => {
    if (response.success) {
      changePhoneNumber(response.imp_uid);
    } else {
      setErrorMessage(response.error_msg);
    }
  };
  const onRequestCertification = () => {
    const data = { name: user?.name, phone: newPhone };
    certificate({
      data,
      callback: certificationCallback,
      prefix: user?.userId,
    });
  };

  const windowSize = useContext(WindowSizeContext);
  const isMobile = windowSize === WindowSize.MOBILE;
  return (
    <>
      {isMobile ? (
        <MobileEditTitle>{`${t('title')}`}</MobileEditTitle>
      ) : (
        <EditTitle>{`${t('title')}`}</EditTitle>
      )}
      <EditDescription $marginTop={isMobile ? '57px' : '39px'}>
        <Trans>{`${t('description')}`}</Trans>
      </EditDescription>
      <EditInputField $marginTop="40px">
        <EditInputContainer>
          <EditInputLabel>{`${t('newPhone.label')}`}</EditInputLabel>
          <EditInputText
            type="tel"
            value={newPhone}
            placeholder={`${t('newPhone.placeholder')}`}
            onChange={e => setNewPhone(e.target.value)}
          />
        </EditInputContainer>
        <CertificationButton onClick={onRequestCertification}>
          {`${t('certificate')}`}
        </CertificationButton>
      </EditInputField>
      <ErrorMessage>{errorMessage}</ErrorMessage>
      {!isLoading || !isPending || <Loading />}
    </>
  );
};
